import { runInAction } from "mobx";
import type {
  BoxContentsData,
  BoxProductItem,
  IWarehouseApi,
  ProductJournalEntry,
} from "../../../api/WarehouseApi";
import { resolveHistoryProductNames } from "./history";

export interface BoxPageLoadingState {
  contents: BoxContentsData | null;
  isLoading: boolean;
  loadError: string | null;
  history: ProductJournalEntry[];
  historyProductNamesById: Record<string, string>;
  isHistoryLoading: boolean;
  historyError: string | null;
}

function resolveErrorMessage(error: unknown, fallback: string): string {
  return error instanceof Error ? error.message : fallback;
}

export async function loadBoxContentsOperation(input: {
  state: BoxPageLoadingState;
  api: IWarehouseApi;
  boxId: string;
}): Promise<void> {
  runInAction(() => {
    input.state.isLoading = true;
    input.state.loadError = null;
  });

  try {
    const data = await input.api.getBoxContents(input.boxId);
    runInAction(() => {
      input.state.contents = data;
    });
  } catch (error) {
    runInAction(() => {
      input.state.loadError = resolveErrorMessage(
        error,
        "Не удалось загрузить содержимое коробки",
      );
    });
  } finally {
    runInAction(() => {
      input.state.isLoading = false;
    });
  }
}

export async function loadBoxHistoryOperation(input: {
  state: BoxPageLoadingState;
  api: IWarehouseApi;
  boxId: string;
  childProducts: BoxProductItem[];
}): Promise<void> {
  runInAction(() => {
    input.state.isHistoryLoading = true;
    input.state.historyError = null;
  });

  try {
    const entries = await input.api.getJournalEntriesByBox(input.boxId, 30);
    const namesMap = await resolveHistoryProductNames({
      api: input.api,
      entries,
      childProducts: input.childProducts,
    });
    runInAction(() => {
      input.state.history = entries;
      input.state.historyProductNamesById = namesMap;
    });
  } catch (error) {
    runInAction(() => {
      input.state.historyError = resolveErrorMessage(
        error,
        "Не удалось загрузить историю коробки",
      );
    });
  } finally {
    runInAction(() => {
      input.state.isHistoryLoading = false;
    });
  }
}
